import "./subscriptions-route.scss";

import * as React from "react";

import {cs}             from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";
import {parseUrlQuery}  from "@Common/utils/parse-url-query";

import {SubHeader}              from "../common/sub-header/sub-header";
import {Layout}                 from "../layout/layout";
import {SubscriptionsDetails}   from "./subscriptions-details";

export const SubscriptionsRoute = ({location}) => cs(
    consumeContext("session"),
    ["agent", ({session}, next) => next(session?.data?.agent)],
    ["query", (_, next) => next(parseUrlQuery(location.search))],
    ["referenceUrl", ({query}, next) => next(
        query?.referrer && query?.id_cart && `/${query.referrer}/${query.id_cart}`
    )],
    ({agent, referenceUrl}) => (
        <Layout
            active="subscriptions"
            className="subscriptions-9gs"
        >
            {SubHeader({
                backLink: {
                    to: referenceUrl ?? "/",
                    label: !referenceUrl ? "Home" : "Back to Checkout",
                },
                title: agent?.subscriptions?.length > 0 ? (
                    <div className="subheader-title"><span>Manage Subscriptions</span><img alt="XD+" src={require("./xdplus-logo.svg")}/></div>
                ) : "",
            })}
            {SubscriptionsDetails({referenceUrl})}
        </Layout>
    )
);
